import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-coil-options-section',
    templateUrl: './coil-options-section.component.html',
    styleUrls: ['./coil-options-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class CoilOptionsSectionComponent implements OnChanges {

  readonly selections = input.required<GuruEntity[]>();
  readonly invalidEntityNames = input.required<string[]>();
  readonly handArrangementImagePath = input<string>(undefined!);
  readonly pipeDetailImagePath = input<string>(undefined!);
  readonly selectionChanged = output<GuruEntity>();
  unionsOnCoilSelection!: GuruEntity;
  coilConstructionSelection!: GuruEntity;
  testPressureSelection!: GuruEntity;
  autoAirVentsSelection!: GuruEntity;
  drainValveSelection!: GuruEntity;
  preHeatSelection!: GuruEntity;
  collapsed: boolean = false;
  canExpand: boolean = true;
  private readonly selectionNames: string[] = ['USUnionsOnCoil', 'USCoilEndSheet', 'USCoilTestPressure', 'USAutoVents', 'USDrainValve', 'USPreHeat'];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filteredSelections: GuruEntity[] = this.selections().filter(selection => this.selectionNames.indexOf(selection.Name) >= 0);
    if (filteredSelections.length === 0) {
      this.collapsed = true;
      this.canExpand = false;
    } else {
      this.unionsOnCoilSelection = this.getSelectionWithName(this.selectionNames[0], filteredSelections);
      this.coilConstructionSelection = this.getSelectionWithName(this.selectionNames[1], filteredSelections);
      this.testPressureSelection = this.getSelectionWithName(this.selectionNames[2], filteredSelections);
      this.autoAirVentsSelection = this.getSelectionWithName(this.selectionNames[3], filteredSelections);
      this.drainValveSelection = this.getSelectionWithName(this.selectionNames[4], filteredSelections);
      this.preHeatSelection = this.getSelectionWithName(this.selectionNames[5], filteredSelections);
    }
  }

  private getSelectionWithName(name: string, selections: GuruEntity[]): GuruEntity {
    for (const selection of selections) {
      if (selection.Name === name) {
        return JSON.parse(JSON.stringify(selection));
      }
    }
    return undefined!;
  }

  selectedValueChanged(selectionName: string, value: string): void {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = selectionName;
    entity.Value = value;
    this.selectionChanged.emit(entity);
  }

  getExpansionIcon(): string {
    return this.collapsed ? 'arrow_drop_down' : 'arrow_drop_up';
  }

  toggleExpansion(): void {
    if (this.canExpand) {
      this.collapsed = !this.collapsed;
    }
  }

  isInvalidSelection(selectionName: string): boolean {
    return this.invalidEntityNames().indexOf(selectionName) >= 0;
  }

}
